var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 463.666C435.162 463.666 463.667 435.162 463.667 400C463.667 364.838 435.162 336.333 400 336.333C364.838 336.333 336.333 364.838 336.333 400C336.333 435.162 364.838 463.666 400 463.666Z",
    stroke: "white",
    strokeWidth: 63.6667,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M686.333 209V750H113.667V50H527.333L686.333 209Z",
    stroke: "white",
    strokeWidth: 63.6667,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M686.333 209V241H495.333V50H527.333L686.333 209Z",
    stroke: "white",
    strokeWidth: 63.6667,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M400 463.667C425.284 463.667 449.532 473.711 467.411 491.589C485.289 509.468 495.333 533.716 495.333 559V592.334H304.667V559C304.667 533.716 314.711 509.468 332.589 491.589C350.468 473.711 374.716 463.667 400 463.667Z",
    stroke: "white",
    strokeWidth: 63.6667,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastersIcon);
export default __webpack_public_path__ + "static/media/masters-icon.a8d3486967fdee8db2c6897b1a180cfa.svg";
export { ForwardRef as ReactComponent };